<mat-card
  class="menu-lateral"
  style="border: 2px solid {{ cor_fundo_cabecalho }}"
>
  <mat-card-header
    class="cabecalho"
    style="background-color: {{ cor_fundo_cabecalho }}"
  >
    <div class="icone">
      <img src="{{ caminho_imagem }}" alt="icone" />
    </div>
    <div class="titulo">
      <mat-card-title>{{ titulo }}</mat-card-title>
    </div>
  </mat-card-header>
  <mat-card-content>
    <ng-content *ngIf="ativosCustomizados; else itensAtivos" select="[ativo]">
    </ng-content>
    <ng-content
      *ngIf="inativosCustomizados; else itensInativos"
      select="[ativo]"
    >
    </ng-content>
    <ng-template #itensAtivos>
      <div *ngFor="let item of ativos; let i = index" class="ativos">
        <a
          [routerLink]="caminhoAtual + item.caminho"
          [ngClass]="item.selecionado ? 'item_selecionado' : 'itens_ativos'"
          (click)="selecionarMenu(item)"
        >
          {{ item.rotulo }}
        </a>
      </div>
    </ng-template>
    <ng-template #itensInativos>
      <div *ngFor="let item of inativos; let i = index" class="inativos">
        <a [routerLink]="item.caminho" class="itens_inativos">
          {{ item.rotulo }}
        </a>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
